<script setup lang="ts">
import './grid-layout.css';
import '@sg-core/src/View/Components/Atoms/Grid/grid.css';
import '@sg-core/src/View/Components/Atoms/Center/center.css';

defineProps({
  use: {
    type: String,
    default: 'div',
  },

  gridSpacing: {
    type: [Number, String],
    default: 4,
  },

  centerSpacing: {
    type: [Number, String],
    default: 4,
  },

  sizing: {
    type: String,
    default: '3xl',
  },

  hasCenterClasses: {
    type: Boolean,
    default: true,
  },
});
</script>

<template>
  <component
    :is="use"
    :class="[
      'phxsg-grid__items phxsg-grid-layout',
      {
        'phxsg-center': hasCenterClasses,
        [`phxsg-grid--spacing-${gridSpacing}`]: gridSpacing,
        [`phxsg-center--spacing-${centerSpacing}`]: centerSpacing && hasCenterClasses,
        [`phxsg-center--sizing-${sizing}`]: sizing && hasCenterClasses,
      },
    ]"
  >
    <slot />
  </component>
</template>
